var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('submit')}}},[(_vm.src)?_c('img',{attrs:{"height":"24px","src":_vm.src,"alt":""}}):_vm._e(),_c('div',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }